<!-- TPOD-3318: no px-2 here. The navbar inside already carries `side-padding` (24px at
     this width), and the extra 8px pushed every drawer row to 32px - out of line with the
     24px the prototype uses, and with the header above it. -->
<div>
    <app-navbar [isMobile]="true" (closeMobileMenu)="closeMenu()"></app-navbar>
</div>
